import { buildAppChipSx } from '../../../../components/chips/AppChip'
import {
  PROFILE_INFO_COPY,
  PROFILE_INFO_STATUS_META
} from '../constants/profileInfoConstants'

export function buildProfileInfoForm(profile) {
  return {
    name: profile?.name || '',
    phone: profile?.phone || ''
  }
}

export function getProfileInfoStatusMeta(profile) {
  if (profile?.status === 'pending') return PROFILE_INFO_STATUS_META.pending
  if (profile?.status === 'inactive') return PROFILE_INFO_STATUS_META.inactive
  return PROFILE_INFO_STATUS_META.active
}

export function getProfilePrimaryRole(profile) {
  const roles = Array.isArray(profile?.roles) ? profile.roles : []
  return roles[0]?.name || PROFILE_INFO_COPY.noRole
}

export function isProfileInfoDirty(form, profile) {
  const profilePhone = profile?.phone || ''
  return (
    form.name.trim() !== (profile?.name || '').trim() ||
    form.phone.trim() !== profilePhone.trim()
  )
}

export function buildProfileStatusChipSx(profile) {
  const meta = getProfileInfoStatusMeta(profile)
  return buildAppChipSx({
    backgroundColor: meta.backgroundColor,
    color: meta.color,
    minWidth: 82,
    padding: '4px 8px',
    lineHeight: 1.2
  })
}

export function buildProfileRoleChipSx() {
  return buildAppChipSx({
    backgroundColor: '#EDE9F6',
    color: '#5E43A6',
    minWidth: 82,
    padding: '4px 8px',
    lineHeight: 1.2
  })
}
